import axios from "axios";

export default function apiCall(type, uri, body) {
  if (type === "post") {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    };
    return axios.post(
      uri,
      body ? body : {},
      localStorage.getItem("jwt") && headers
    );
  }
  if (type === "put") {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    };
    return axios.put(
      uri,
      body ? body : {},
      localStorage.getItem("jwt") && headers
    );
  } else if (type === "delete") {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    };
    return axios.delete(uri, localStorage.getItem("jwt") && headers);
  } else if (type === "get") {
    const headers = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    };
    return axios.get(uri, localStorage.getItem("jwt") && headers);
  } else return new Error("Invalid Http Method");
}
